(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["d-header-new-layout"]) return;
  try {
    
  /* Megamenu hover behavior */
  document.addEventListener('DOMContentLoaded', function () {
    // Considerar como mobile também a faixa de 990px-1240px (desktops menores)
    const isMobile = () => window.innerWidth < 990;
    const isTablet = () => window.innerWidth >= 990 && window.innerWidth <= 1240;
    const menuContainers = document.querySelectorAll('.mega-menu-container');

    // Forçar fechamento inicial dos menus na resolução 1024px
    function closeAllMenus() {
      document.querySelectorAll('.mega-menu__content').forEach((menu) => {
        menu.setAttribute('aria-hidden', 'true');
      });
    }

    // Inicializar menus fechados
    closeAllMenus();

    // Adicionar evento de resize para garantir que menus fiquem fechados quando mudar para resolução 1024px
    window.addEventListener('resize', function () {
      if (isTablet()) {
        closeAllMenus();
      }
    });

    // Adicionar comportamento para dispositivos móveis
    menuContainers.forEach((container) => {
      // Fechar todos os menus ao iniciar
      const megaMenu = container.querySelector('.mega-menu__content');
      if (megaMenu) megaMenu.setAttribute('aria-hidden', 'true');

      // Em dispositivos móveis, adicionar toggle para mostrar/esconder o menu
      container.addEventListener('click', function (e) {
        // Evitar comportamento de toggle em dispositivos tablet (1024px), deixando o hover funcionar como no desktop
        if (isMobile() && e.target.closest('.header__menu-item')) {
          e.preventDefault();
          const megaMenu = this.querySelector('.mega-menu__content');
          const expanded = megaMenu.getAttribute('aria-hidden') !== 'true';

          // Fechar todos os outros menus
          document.querySelectorAll('.mega-menu__content').forEach((menu) => {
            if (menu !== megaMenu) menu.setAttribute('aria-hidden', 'true');
          });

          // Toggle deste menu
          megaMenu.setAttribute('aria-hidden', expanded ? 'true' : 'false');
        }
      });
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.stickyDisabled = this.stickyType === 'none';
      this.headerBounds = {};
      this.isTransparent = this.hasAttribute('transparent');

      this.makeSectionGroupSticky();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (!this.stickyDisabled) {
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      this.createObserver();
    }

    makeSectionGroupSticky() {
      if (!this.headerIsAlwaysSticky) return;
      const sectionEl = this.header;
      if (!sectionEl) return;

      let target = null;
      let el = sectionEl.parentElement;
      while (el && el !== document.body) {
        if (!el.classList.contains('shopify-section')) {
          target = el;
          break;
        }
        el = el.parentElement;
      }

      if (!target) target = sectionEl;

      target.style.setProperty('position', 'sticky', 'important');
      target.style.setProperty('top', '0', 'important');
      target.style.setProperty('z-index', '999', 'important');
    }

    setHeaderHeight() {
      const headerHeight = this.header.querySelector('.header-wrapper').offsetHeight;
      if (!headerHeight) return;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.updateTransparentState(window.pageYOffset || document.documentElement.scrollTop);
      });

      observer.observe(this.header);
    }

    updateTransparentState(scrollTop) {
      if (!this.isTransparent) return;
      if (this.getAttribute('data-sticky-type') === 'none') {
        this.removeAttribute('data-sticky-state');
        return;
      }

      const threshold = this.headerBounds?.bottom ?? 0;
      if (scrollTop > threshold) {
        this.setAttribute('data-sticky-state', 'active');
      } else {
        this.removeAttribute('data-sticky-state');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateTransparentState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
